import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

const EMAIL = 'contact@squarebitstudios.com';

const ContactPage: React.FC = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(EMAIL);
    setCopied(true);
    toast.success(t('contact.emailCopied'));
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-6 py-24 text-center">
      <h1 className="font-display font-bold text-[36px] md:text-[48px] tracking-[-0.03em] leading-[1.1] text-content-dark mb-4">
        {t('contact.title')}
      </h1>
      <p className="text-content-muted-alt text-[15px] leading-relaxed max-w-[420px] mb-4">
        {t('contact.description1')} {t('contact.description2')}
      </p>
      <p className="text-content-muted-alt text-[14px] leading-relaxed max-w-[520px] mb-10">
        {t('contact.salesNote')}
      </p>

      <div className="flex items-center gap-[10px]">
        {/* Email display with copy action */}
        <div className="inline-flex items-center gap-[10px] pl-[24px] pr-[8px] py-[8px] rounded-[32px] bg-surface border border-border-brand">
          <span className="font-medium text-[15px] tracking-[-0.01em] text-content-dark select-all">
            {EMAIL}
          </span>
          <button
            onClick={handleCopy}
            title={t('common.copy')}
            aria-label={t('common.copy')}
            className="inline-flex items-center justify-center w-[34px] h-[34px] rounded-full bg-blue text-surface-base transition-all duration-200 hover:bg-blue-deep-1 hover:shadow-[0px_0px_0px_4px_rgba(93,225,255,0.25)]"
          >
            {copied ? (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M3 8l3.5 3.5L13 4.5"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect
                  x="5.5"
                  y="5.5"
                  width="8"
                  height="9"
                  rx="1.5"
                  stroke="currentColor"
                  strokeWidth="1.25"
                />
                <path
                  d="M5.5 10.5H3.5a1 1 0 01-1-1v-7a1 1 0 011-1h7a1 1 0 011 1v2"
                  stroke="currentColor"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Mailto icon button */}
        <a
          href={`mailto:${EMAIL}`}
          className="inline-flex items-center justify-center w-[50px] h-[50px] rounded-full border border-blue-100 bg-surface text-blue transition-all duration-200 hover:bg-surface-hover hover:shadow-[0px_0px_0px_4px_rgba(93,225,255,0.20)]"
          title={t('auth.openInMailApp')}
          aria-label={t('auth.openInMailApp')}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
              d="M2 5h14v10a1 1 0 01-1 1H3a1 1 0 01-1-1V5z"
              stroke="currentColor"
              strokeWidth="1.25"
              strokeLinejoin="round"
            />
            <path
              d="M2 5l7 6 7-6"
              stroke="currentColor"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default ContactPage;
